// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"blog-module--wrapper--2BNRD","heroHeading":"blog-module--heroHeading--35LDi typography-module--h1Big--3p7ek","heroDescription":"blog-module--heroDescription--1Z2Jd"};